"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILCustomIcon = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var il_custom_icon_definitions_1 = require("./il-custom-icon-definitions");
var ILCustomIcon = function (props) {
    var classes = 'il-custom-icon ' + props.className;
    var selectedIcon = il_custom_icon_definitions_1.IlCustomIcons[props.type];
    var backgroundColor = props.backgroundColor || (selectedIcon && selectedIcon.backgroundColor);
    var ImageComponent = (selectedIcon === null || selectedIcon === void 0 ? void 0 : selectedIcon.icon) || props.icon;
    var size = props.size || '2rem';
    return (react_1.default.createElement(Box_1.default, { "data-testid": props.dataTestId, container: props.boxElement || 'div',
        className: classes,
        sx: __assign({ width: size, height: size, padding: 0.5, borderRadius: '4px', backgroundColor: backgroundColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }, props.sx) },
        ImageComponent && react_1.default.createElement(ImageComponent, { style: { width: size, height: size } }),
        props.children));
};
exports.ILCustomIcon = ILCustomIcon;
